import { InboundFaxNotes } from "@/Documents/Models/InboundFax/InboundFaxNotes";

class InboundFax {
    public Id: string;
    public IsUrgent: boolean;
    public SenderFaxNumber: string;
    public DateReceived: Date;
    public Source: string;
    public ClassName: string;
    public DeletedPageCount: number;
    public PendingPageCount: number;
    public AssignedPageCount: number;
    public CreatedDate: Date;
    public ReportClassLookupId: string;
    public ReportSubClassLookupId: string;
    public AttachmentId: string;
    public ReadDate: Date;
    public FaxNotes: InboundFaxNotes[] = [];
    public FaxSourceClassLookupId: string;
    public FaxSourceSubClassLookupId: string;

    constructor(responseModel: InboundFax) {
        this.Id = responseModel.Id;
        this.SenderFaxNumber = responseModel.SenderFaxNumber;
        this.DateReceived = responseModel.DateReceived;
        this.IsUrgent = responseModel.IsUrgent;
        this.CreatedDate = responseModel.CreatedDate;
        this.Source = responseModel.Source;
        this.ClassName = responseModel.ClassName;
        this.DeletedPageCount = responseModel?.DeletedPageCount ?? 0;
        this.PendingPageCount = responseModel?.PendingPageCount ?? 0;
        this.AssignedPageCount = responseModel?.AssignedPageCount ?? 0;
        this.AttachmentId = responseModel.AttachmentId;
        this.ReadDate = responseModel.ReadDate;
        this.ReportClassLookupId = responseModel.ReportClassLookupId;
        this.ReportSubClassLookupId = responseModel.ReportSubClassLookupId;
        this.FaxNotes = responseModel.FaxNotes;
        this.FaxSourceClassLookupId = responseModel.FaxSourceClassLookupId;
        this.FaxSourceSubClassLookupId = responseModel.FaxSourceSubClassLookupId;
    }

    /**
     * Return class lookup Id in priority of fax and faxSource
     * @param inboundFax
     * @returns
     */
    public static getClassLookupId(inboundFax: InboundFax): string {
        if (!inboundFax) {
            return "";
        }
        return inboundFax.ReportClassLookupId || inboundFax.FaxSourceClassLookupId || "";
    }

    /**
     * Return sub-class lookup Id in priority of fax and faxSource
     * @param inboundFax
     * @returns
     */
    public static getSubClassLookupId(inboundFax: InboundFax): string {
        if (!inboundFax) {
            return "";
        }
        return inboundFax.ReportSubClassLookupId || inboundFax.FaxSourceSubClassLookupId || "";
    }
}

export { InboundFax };
